import { Component, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UfFilterFacade } from '../../facades/UfFilter.facade';
import { IUf } from '../../types/IUf';

@Component({
    selector: 'uf-filter-list',
    templateUrl: './uf-filter-list.component.html',
    styleUrls: ['./uf-filter-list.component.scss'],
    standalone: false
})
export class UFFilterListComponent implements OnInit {
  public ufs: IUf[];

  constructor(
    public ufFilterFacade: UfFilterFacade,
    public activatedRoute: ActivatedRoute,
  ) {
    this.activatedRoute.params.subscribe(_ => {
      this.ngOnInit();
    });
  }

  ngOnInit(): void {
    this.ufFilterFacade.fetchUfs();
  }

  filter(uf: IUf) {
    this.ufFilterFacade.filterHealthPlans(uf.uf);
    this.ufFilterFacade.filterProductMaterials(uf.uf);
  }

  clearFilters() {
    this.ufFilterFacade.clearHealthPlansFilter();
    this.ufFilterFacade.clearProductMaterialsFilter();
  }
}
